export default {
    getOptions: {
        config: {
            url: '/option/getKv',
            method: 'get',
        },
    }
}